import {SSOGuard} from '@mtfe/sso-web';

const ENV = process.env;
const isProduction = window.location.host === 'operation.sankuai.com' || window.location.host === 'tjt.sec.st.sankuai.com';

const clientId = isProduction ? ENV.VUE_APP_CLIENT_ID_PROD : ENV.VUE_APP_CLIENT_ID;
// SSO HOST
const sso_host = isProduction ? 'https://ssosv.sankuai.com/sson' : 'http://ssosv.it.test.sankuai.com/sson'
// 登录URL
const login_origin = `${sso_host}/login`;
// 登出URL
const logout_origin = `${sso_host}/logout`;

export const ssoGuard = new SSOGuard({
  clientId: clientId, // 这里要写当前项目的 clientId  必填
  // test or product
  accessEnv: isProduction ? 'product' : 'test',
  appkey: 'com.sankuai.platform.operation'
});
ssoGuard.init();

const sso = {
  doLogin() {
    //登录域名
    const {origin, href} = window.location;
    // CallBackURL
    const sso_callback_url = `${origin}/api/sso/callback`;
    const currentPath = href.replace(new RegExp(`^${origin}`), '');
    const login_url = `${login_origin}?client_id=${clientId}&redirect_uri=${encodeURIComponent(`${sso_callback_url}?original-url=${encodeURIComponent(currentPath)}`)}`;
    window.location.href = login_url;
  },
  logout() {
    const {origin, href} = window.location;
    const currentPath = href.replace(new RegExp(`^${origin}`), '');
    const sso_logout_url = `${origin}/api/sso/callback`;
    const logout_url = `${logout_origin}?client_id=${clientId}&redirect_uri=${encodeURIComponent(`${sso_logout_url}?original-url=${encodeURIComponent(currentPath)}`)}`;
    window.location.href = logout_url;
  },
  isProd() {
    return isProduction;
  },
};

export default sso
